import { Tabs as TabsBase, TabList, Tab, TabPanel } from 'react-tabs';
import './style.scss';

type TabsProps = {
  tabLists: { title: string; extra?: React.ReactNode }[];
  tabContents: React.ReactNode[];
  selectedIndex: number;
  onSelect: (index: number) => void;
};

export const Tabs = (props: TabsProps) => {
  const { tabLists, tabContents, selectedIndex, onSelect } = props;
  return (
    <TabsBase className="react-tabs" selectedIndex={selectedIndex} onSelect={onSelect}>
      <TabList className="react-tabs__tab-list">
        {tabLists.map((item, index) => (
          <Tab className="react-tabs__tab" key={index}>
            <span>{item.title}</span>
            {item.extra}
          </Tab>
        ))}
      </TabList>
      {tabContents.map((tabContent, index) => (
        <TabPanel className="react-tabs__tab-panel" key={index}>
          {tabContent}
        </TabPanel>
      ))}
    </TabsBase>
  );
};
